import PropTypes from 'prop-types';

import {NotificationFillIcon} from '../../../svg/NotificationFillIcon';
import {NotificationLineIcon} from '../../../svg/NotificationLineIcon';
import {NotificationsView} from '../NotificationsView/NotificationsView';
import {useMatchQuery} from '../../../hooks/useMatchQuery';

import './NotificationsWrapper.sass';

export const NotificationsWrapper = (props) => {
  /** Media query hooks */
  const {matches: lgWindow} = useMatchQuery('(min-width: 80rem)', []);

  return (
    <div id="pbNotificationsView" className="notifications-container">
      <button
        className="unstyled-button notification-bell-button"
        onClick={props.onNotificationsClick}
        data-qa-id="notificationBellIconButton"
      >
        {props.notificationsObj.notifications &&
        props.notificationsObj.notifications.filter((n) => !n.read).length > 0 ? (
          <NotificationFillIcon ratio={lgWindow ? 0.75 : 0.5} />
        ) : (
          <NotificationLineIcon ratio={lgWindow ? 0.75 : 0.5} />
        )}
      </button>
      <div
        className={`notifications-view-wrapper ${props.notificationsViewOpen ? 'open' : ''} ${
          lgWindow ? 'large-window' : ''
        }`}
        id="notificationsMenu"
      >
        <NotificationsView
          {...props.notificationsObj}
          onMarkAllAsRead={props.onMarkAllAsRead}
          onMarkOneAsRead={props.onMarkOneAsRead}
          onMarkOneAsUnread={props.onMarkOneAsUnread}
          onHideNotification={props.onHideNotification}
        />
      </div>
    </div>
  );
};

NotificationsWrapper.propTypes = {
  notificationsViewOpen: PropTypes.bool,
  onNotificationsViewOpen: PropTypes.func,
  notificationsObj: PropTypes.object.isRequired,
  onMarkAllAsRead: PropTypes.func.isRequired,
  onMarkOneAsRead: PropTypes.func.isRequired,
  onMarkOneAsUnread: PropTypes.func.isRequired,
  onHideNotification: PropTypes.func.isRequired,
};
